export function dialog() {
    let openDialogBtn = document.querySelectorAll('[data-openDialog]');
    let dialogs = document.querySelectorAll('dialog');
    let closeDialogBtn = document.querySelectorAll('[data-closeDialog]');

    function openDialog(evt, btn) {
        evt.preventDefault();
        dialogs.forEach((el) => el.close());
        let dialogTarget = btn.getAttribute('data-openDialog');
        dialogTarget = document.querySelector(dialogTarget);
        dialogTarget.showModal();
    }

    function closeDialog(btn) {
        let dialogTarget = btn.closest('dialog');
        dialogTarget.close();
    }

    const handleDialogClick = ({ currentTarget, target }) => {
        const isClickedOnBackdrop = target === currentTarget;

        if (isClickedOnBackdrop) {
            currentTarget.close();
        }
    }

    openDialogBtn.forEach(btn => btn.addEventListener('click', evt => openDialog(evt, btn)));
    closeDialogBtn.forEach(btn => btn.addEventListener('click', evt => closeDialog(btn)));
    dialogs.forEach(el => el.addEventListener('click', handleDialogClick));
}
